import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
export function TargetAudience() {
  return <section className="py-20 bg-brand-cream" data-id="element-172">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-173">
        <div className="text-center mb-16" data-id="element-174">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-teal mb-4" data-id="element-175">
            ¿Para quién es este protocolo?
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-176">
          {/* Green Checklist */}
          <div className="bg-white rounded-2xl p-8 border-t-4 border-green-500 shadow-lg" data-id="element-177">
            <h3 className="text-2xl font-bold text-brand-dark mb-6 flex items-center gap-2" data-id="element-178">
              <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-179" />
              ESTO SÍ ES PARA TI SI...
            </h3>
            <ul className="space-y-4" data-id="element-180">
              <li className="flex items-start gap-3" data-id="element-181">
                <div className="mt-1 bg-green-100 p-1 rounded-full" data-id="element-182">
                  <CheckCircle2 className="w-4 h-4 text-green-600" data-id="element-183" />
                </div>
                <span className="text-gray-700" data-id="element-184">
                  Eres una madre cansada de terapias que no muestran avances
                  reales.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-185">
                <div className="mt-1 bg-green-100 p-1 rounded-full" data-id="element-186">
                  <CheckCircle2 className="w-4 h-4 text-green-600" data-id="element-187" />
                </div>
                <span className="text-gray-700" data-id="element-188">
                  Vives en Latinoamérica y necesitas soluciones con un
                  presupuesto real y accesible.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-189">
                <div className="mt-1 bg-green-100 p-1 rounded-full" data-id="element-190">
                  <CheckCircle2 className="w-4 h-4 text-green-600" data-id="element-191" />
                </div>
                <span className="text-gray-700" data-id="element-192">
                  Tu hijo presenta ojeras crónicas, panza hinchada o mirada
                  ausente/desconectada.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-193">
                <div className="mt-1 bg-green-100 p-1 rounded-full" data-id="element-194">
                  <CheckCircle2 className="w-4 h-4 text-green-600" data-id="element-195" />
                </div>
                <span className="text-gray-700" data-id="element-196">
                  Estás dispuesta a tomar acción y cambiar hábitos en la cocina.
                </span>
              </li>
            </ul>
          </div>

          {/* Red Checklist */}
          <div className="bg-white rounded-2xl p-8 border-t-4 border-red-500 shadow-lg" data-id="element-197">
            <h3 className="text-2xl font-bold text-brand-dark mb-6 flex items-center gap-2" data-id="element-198">
              <XCircle className="w-6 h-6 text-red-500" data-id="element-199" />
              ESTO NO ES PARA TI SI...
            </h3>
            <ul className="space-y-4" data-id="element-200">
              <li className="flex items-start gap-3" data-id="element-201">
                <div className="mt-1 bg-red-100 p-1 rounded-full" data-id="element-202">
                  <XCircle className="w-4 h-4 text-red-600" data-id="element-203" />
                </div>
                <span className="text-gray-700" data-id="element-204">
                  Eres una persona que busca una "pastilla mágica" sin hacer
                  cambios de raíz.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-205">
                <div className="mt-1 bg-red-100 p-1 rounded-full" data-id="element-206">
                  <XCircle className="w-4 h-4 text-red-600" data-id="element-207" />
                </div>
                <span className="text-gray-700" data-id="element-208">
                  No quieres dejar de comprar y darles alimentos
                  ultraprocesados.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-209">
                <div className="mt-1 bg-red-100 p-1 rounded-full" data-id="element-210">
                  <XCircle className="w-4 h-4 text-red-600" data-id="element-211" />
                </div>
                <span className="text-gray-700" data-id="element-212">
                  Prefieres gastar USD 500 en laboratorios extranjeros en lugar
                  de sanar el intestino.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}